if (!customElements.get('yg-content-panel')) {
  customElements.define('yg-content-panel', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const items = [...this.querySelectorAll('details.yg-content__item')].filter(item => item.closest('yg-content-panel') === this);
      if (!this.initialized) {
        if (this.dataset.openFirst === 'true' && !items.some(item => item.open) && items[0]) items[0].open = true;
        if (this.dataset.singleOpen === 'true') {
          let openFound = false;
          items.forEach(item => { if (item.open) { if (openFound) item.open = false; openFound = true; } });
        }
        this.initialized = true;
      }
      items.forEach(item => {
        if (this.dataset.singleOpen === 'true') item.name = this.id;
        item.addEventListener('toggle', () => {
          if (item.open && this.dataset.singleOpen === 'true') items.forEach(other => { if (other !== item) other.open = false; });
        }, { signal });
      });
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('details.yg-content__item');
        if (item && this.contains(item)) item.open = true;
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
if (!window.ygImageContentActions) {
  window.ygImageContentActions = true;
  document.addEventListener('click', event => {
    const videoButton = event.target.closest('.yg-content__video-toggle');
    if (videoButton) {
      const video = videoButton.parentElement.querySelector('video');
      if (!video) return;
      if (video.paused) video.play().then(() => { videoButton.textContent = 'Ⅱ'; videoButton.setAttribute('aria-label',videoButton.dataset.pauseLabel); }).catch(() => {});
      else { video.pause(); videoButton.textContent = '▶'; videoButton.setAttribute('aria-label',videoButton.dataset.playLabel); }
    }
  });
}
